import { render } from "./Layout.vue?vue&type=template&id=6bf30086"
import script from "./Layout.vue?vue&type=script&lang=js"
export * from "./Layout.vue?vue&type=script&lang=js"

import exportComponent from "/Users/herianto/Projects/yeu-logistik/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Shared/Layout.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6bf30086"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6bf30086', __exports__)) {
    console.log('reload')
    api.reload('6bf30086', __exports__)
  }
  
  module.hot.accept("./Layout.vue?vue&type=template&id=6bf30086", () => {
    console.log('re-render')
    api.rerender('6bf30086', render)
  })

}


export default __exports__